import { environment } from 'src/environments/environment';
import { Page } from '../navigation/pages.model';
export const utils = {
    product_extras: [
      {field: 'extra_2', type: 'select', name: $localize `DMC`},
      {field: 'extra_3', type: 'select', name: $localize `Sposób pakowania`},
    ],
    client_extras: [
      {field: 'extended_1', type: 'text', name: $localize `Strona www`, default:'', required: false, error: $localize `Maksymalnie 100 znaków`, max: 100},
      {field: 'extended_2', type: 'text', name: $localize `Rok powstania firmy`, default:'', required: false, error: $localize `Maksymalnie 255 znaków`, max: 255},
      {field: 'extended_3', type: 'text', name: $localize `Ilu pracowników zatrudnia firma`, default:'', required: false, error: $localize `Maksymalnie 100 znaków`, max: 100},
      {field: 'extended_4', type: 'radio', name: $localize `Czy jesteś już dealerem przyczep?`, default:'', required: false, error: $localize `Maksymalnie 5 znaków`, max: 5},
      {field: 'extended_5', type: 'radio', name: $localize `Czy posiada Pan/Pani więcej niż 1 punkt sprzedaży?`, default:'', required: false, error: $localize `Maksymalnie 5 znaków`, max: 5},
      {field: 'extended_6', type: 'radio', name: $localize `Czy dysponuje Pan/Pani możliwościami napraw przyczep?`, default:'', required: false, error: $localize `Maksymalnie 5 znaków`, max: 5},
      {field: 'extended_7', type: 'radio', name: $localize `Czy jest Pan/Pani zainteresowana zintegrowaną stroną internetową oraz wsparciem marketingowym?`, default:'', required: false, error: $localize `Maksymalnie 5 znaków`, max: 5},
      {field: 'extended_8', type: 'text', name: $localize `Skąd dowiedział/a się Pan/Pani o nas?`, default:'', required: false, error: $localize `Maksymalnie 255 znaków`, max: 255},
    ],
    countries: [
      {value: 'AL', viewValue:  $localize `Albania`},
      {value: 'DZ', viewValue:  $localize `Algieria`},
      {value: 'AD', viewValue:  $localize `Andora`},
      {value: 'AO', viewValue:  $localize `Angola`},
      {value: 'AI', viewValue:  $localize `Anguilla`},
      {value: 'AQ', viewValue:  $localize `Antarktyka`},
      {value: 'AG', viewValue:  $localize `Antigua i Barbuda`},
      {value: 'SA', viewValue:  $localize `Arabia Saudyjska`},
      {value: 'AR', viewValue:  $localize `Argentyna`},
      {value: 'AM', viewValue:  $localize `Armenia`},
      {value: 'AW', viewValue:  $localize `Aruba`},
      {value: 'AU', viewValue:  $localize `Australia`},
      {value: 'AT', viewValue:  $localize `Austria`},
      {value: 'AZ', viewValue:  $localize `Azerbejdżan`},
      {value: 'BS', viewValue:  $localize `Bahamy`},
      {value: 'BH', viewValue:  $localize `Bahrajn`},
      {value: 'BD', viewValue:  $localize `Bangladesz`},
      {value: 'BB', viewValue:  $localize `Barbados`},
      {value: 'BE', viewValue:  $localize `Belgia`},
      {value: 'BZ', viewValue:  $localize `Belize`},
      {value: 'BJ', viewValue:  $localize `Benin`},
      {value: 'BM', viewValue:  $localize `Bermudy`},
      {value: 'BT', viewValue:  $localize `Bhutan`},
      {value: 'BY', viewValue:  $localize `Białoruś`},
      {value: 'BO', viewValue:  $localize `Boliwia`},
      {value: 'BQ', viewValue:  $localize `Bonaire, Sint Eustatius i Saba`},
      {value: 'BA', viewValue:  $localize `Bośnia i Hercegowina`},
      {value: 'BW', viewValue:  $localize `Botswana`},
      {value: 'BR', viewValue:  $localize `Brazylia`},
      {value: 'BN', viewValue:  $localize `Brunei`},
      {value: 'IO', viewValue:  $localize `Brytyjskie Terytorium Oceanu Indyjskiego`},
      {value: 'VG', viewValue:  $localize `Brytyjskie Wyspy Dziewicze`},
      {value: 'BG', viewValue:  $localize `Bułgaria`},
      {value: 'BF', viewValue:  $localize `Burkina Faso`},
      {value: 'BI', viewValue:  $localize `Burundi`},
      {value: 'CL', viewValue:  $localize `Chile`},
      {value: 'CN', viewValue:  $localize `Chiny`},
      {value: 'HR', viewValue:  $localize `Chorwacja`},
      {value: 'CW', viewValue:  $localize `Curaçao`},
      {value: 'CY', viewValue:  $localize `Cypr`},
      {value: 'TD', viewValue:  $localize `Czad`},
      {value: 'ME', viewValue:  $localize `Czarnogóra`},
      {value: 'CZ', viewValue:  $localize `Czechy`},
      {value: 'UM', viewValue:  $localize `Dalekie Wyspy Mniejsze Stanów Zjednoczonych`},
      {value: 'DK', viewValue:  $localize `Dania`},
      {value: 'CD', viewValue:  $localize `Demokratyczna Republika Konga`},
      {value: 'DM', viewValue:  $localize `Dominika`},
      {value: 'DO', viewValue:  $localize `Dominikana`},
      {value: 'DJ', viewValue:  $localize `Dżibuti`},
      {value: 'EG', viewValue:  $localize `Egipt`},
      {value: 'EC', viewValue:  $localize `Ekwador`},
      {value: 'ER', viewValue:  $localize `Erytrea`},
      {value: 'EE', viewValue:  $localize `Estonia`},
      {value: 'SZ', viewValue:  $localize `Eswatini`},
      {value: 'ET', viewValue:  $localize `Etiopia`},
      {value: 'FK', viewValue:  $localize `Falklandy`},
      {value: 'FJ', viewValue:  $localize `Fidżi`},
      {value: 'PH', viewValue:  $localize `Filipiny`},
      {value: 'FI', viewValue:  $localize `Finlandia`},
      {value: 'FR', viewValue:  $localize `Francja`},
      {value: 'TF', viewValue:  $localize `Francuskie Terytoria Południowe i Antarktyczne`},
      {value: 'GA', viewValue:  $localize `Gabon`},
      {value: 'GM', viewValue:  $localize `Gambia`},
      {value: 'GS', viewValue:  $localize `Georgia Południowa i Sandwich Południowy`},
      {value: 'GH', viewValue:  $localize `Ghana`},
      {value: 'GI', viewValue:  $localize `Gibraltar`},
      {value: 'GR', viewValue:  $localize `Grecja`},
      {value: 'GD', viewValue:  $localize `Grenada`},
      {value: 'GL', viewValue:  $localize `Grenlandia`},
      {value: 'GE', viewValue:  $localize `Gruzja`},
      {value: 'GU', viewValue:  $localize `Guam`},
      {value: 'GG', viewValue:  $localize `Guernsey`},
      {value: 'GF', viewValue:  $localize `Gujana Francuska`},
      {value: 'GY', viewValue:  $localize `Gujana`},
      {value: 'GP', viewValue:  $localize `Gwadelupa`},
      {value: 'GT', viewValue:  $localize `Gwatemala`},
      {value: 'GW', viewValue:  $localize `Gwinea Bissau`},
      {value: 'GQ', viewValue:  $localize `Gwinea Równikowa`},
      {value: 'GN', viewValue:  $localize `Gwinea`},
      {value: 'HT', viewValue:  $localize `Haiti`},
      {value: 'ES', viewValue:  $localize `Hiszpania`},
      {value: 'NL', viewValue:  $localize `Holandia`},
      {value: 'HN', viewValue:  $localize `Honduras`},
      {value: 'HK', viewValue:  $localize `Hongkong`},
      {value: 'IN', viewValue:  $localize `Indie`},
      {value: 'ID', viewValue:  $localize `Indonezja`},
      {value: 'IQ', viewValue:  $localize `Irak`},
      {value: 'IR', viewValue:  $localize `Iran`},
      {value: 'IE', viewValue:  $localize `Irlandia`},
      {value: 'IS', viewValue:  $localize `Islandia`},
      {value: 'IL', viewValue:  $localize `Izrael`},
      {value: 'JM', viewValue:  $localize `Jamajka`},
      {value: 'JP', viewValue:  $localize `Japonia`},
      {value: 'YE', viewValue:  $localize `Jemen`},
      {value: 'JE', viewValue:  $localize `Jersey`},
      {value: 'JO', viewValue:  $localize `Jordania`},
      {value: 'KY', viewValue:  $localize `Kajmany`},
      {value: 'KH', viewValue:  $localize `Kambodża`},
      {value: 'CM', viewValue:  $localize `Kamerun`},
      {value: 'CA', viewValue:  $localize `Kanada`},
      {value: 'QA', viewValue:  $localize `Katar`},
      {value: 'KZ', viewValue:  $localize `Kazachstan`},
      {value: 'KE', viewValue:  $localize `Kenia`},
      {value: 'KG', viewValue:  $localize `Kirgistan`},
      {value: 'KI', viewValue:  $localize `Kiribati`},
      {value: 'CO', viewValue:  $localize `Kolumbia`},
      {value: 'KM', viewValue:  $localize `Komory`},
      {value: 'CG', viewValue:  $localize `Kongo`},
      {value: 'KR', viewValue:  $localize `Korea Południowa`},
      {value: 'KP', viewValue:  $localize `Korea Północna`},
      {value: 'CR', viewValue:  $localize `Kostaryka`},
      {value: 'CU', viewValue:  $localize `Kuba`},
      {value: 'KW', viewValue:  $localize `Kuwejt`},
      {value: 'LA', viewValue:  $localize `Laos`},
      {value: 'LS', viewValue:  $localize `Lesotho`},
      {value: 'LB', viewValue:  $localize `Liban`},
      {value: 'LR', viewValue:  $localize `Liberia`},
      {value: 'LY', viewValue:  $localize `Libia`},
      {value: 'LI', viewValue:  $localize `Liechtenstein`},
      {value: 'LT', viewValue:  $localize `Litwa`},
      {value: 'LU', viewValue:  $localize `Luksemburg`},
      {value: 'LV', viewValue:  $localize `Łotwa`},
      {value: 'MK', viewValue:  $localize `Macedonia`},
      {value: 'MG', viewValue:  $localize `Madagaskar`},
      {value: 'YT', viewValue:  $localize `Majotta`},
      {value: 'MO', viewValue:  $localize `Makau`},
      {value: 'MW', viewValue:  $localize `Malawi`},
      {value: 'MV', viewValue:  $localize `Malediwy`},
      {value: 'MY', viewValue:  $localize `Malezja`},
      {value: 'ML', viewValue:  $localize `Mali`},
      {value: 'MT', viewValue:  $localize `Malta`},
      {value: 'MP', viewValue:  $localize `Mariany Północne`},
      {value: 'MA', viewValue:  $localize `Maroko`},
      {value: 'MQ', viewValue:  $localize `Martynika`},
      {value: 'MR', viewValue:  $localize `Mauretania`},
      {value: 'MU', viewValue:  $localize `Mauritius`},
      {value: 'MX', viewValue:  $localize `Meksyk`},
      {value: 'FM', viewValue:  $localize `Mikronezja`},
      {value: 'MM', viewValue:  $localize `Mjanma`},
      {value: 'MD', viewValue:  $localize `Mołdawia`},
      {value: 'MC', viewValue:  $localize `Monako`},
      {value: 'MN', viewValue:  $localize `Mongolia`},
      {value: 'MS', viewValue:  $localize `Montserrat`},
      {value: 'MZ', viewValue:  $localize `Mozambik`},
      {value: 'NA', viewValue:  $localize `Namibia`},
      {value: 'NR', viewValue:  $localize `Nauru`},
      {value: 'NP', viewValue:  $localize `Nepal`},
      {value: 'DE', viewValue:  $localize `Niemcy`},
      {value: 'NE', viewValue:  $localize `Niger`},
      {value: 'NG', viewValue:  $localize `Nigeria`},
      {value: 'NI', viewValue:  $localize `Nikaragua`},
      {value: 'NU', viewValue:  $localize `Niue`},
      {value: 'NF', viewValue:  $localize `Norfolk`},
      {value: 'NO', viewValue:  $localize `Norwegia`},
      {value: 'NC', viewValue:  $localize `Nowa Kaledonia`},
      {value: 'NZ', viewValue:  $localize `Nowa Zelandia`},
      {value: 'OM', viewValue:  $localize `Oman`},
      {value: 'PK', viewValue:  $localize `Pakistan`},
      {value: 'PW', viewValue:  $localize `Palau`},
      {value: 'PS', viewValue:  $localize `Palestyna`},
      {value: 'PA', viewValue:  $localize `Panama`},
      {value: 'PG', viewValue:  $localize `Papua-Nowa Gwinea`},
      {value: 'PY', viewValue:  $localize `Paragwaj`},
      {value: 'PE', viewValue:  $localize `Peru`},
      {value: 'PN', viewValue:  $localize `Pitcairn`},
      {value: 'PF', viewValue:  $localize `Polinezja Francuska`},
      {value: 'PL', viewValue:  $localize `Polska`},
      {value: 'PR', viewValue:  $localize `Portoryko`},
      {value: 'PT', viewValue:  $localize `Portugalia`},
      {value: 'ZA', viewValue:  $localize `Południowa Afryka`},
      {value: 'CF', viewValue:  $localize `Republika Środkowoafrykańska`},
      {value: 'CV', viewValue:  $localize `Republika Zielonego Przylądka`},
      {value: 'RE', viewValue:  $localize `Reunion`},
      {value: 'RU', viewValue:  $localize `Rosja`},
      {value: 'RO', viewValue:  $localize `Rumunia`},
      {value: 'RW', viewValue:  $localize `Rwanda`},
      {value: 'EH', viewValue:  $localize `Sahara Zachodnia`},
      {value: 'KN', viewValue:  $localize `Saint Kitts i Nevis`},
      {value: 'LC', viewValue:  $localize `Saint Lucia`},
      {value: 'VC', viewValue:  $localize `Saint Vincent i Grenadyny`},
      {value: 'BL', viewValue:  $localize `Saint-Barthélemy`},
      {value: 'MF', viewValue:  $localize `Saint-Martin`},
      {value: 'PM', viewValue:  $localize `Saint-Pierre i Miquelon`},
      {value: 'SV', viewValue:  $localize `Salwador`},
      {value: 'AS', viewValue:  $localize `Samoa Amerykańskie`},
      {value: 'WS', viewValue:  $localize `Samoa`},
      {value: 'SM', viewValue:  $localize `San Marino`},
      {value: 'SN', viewValue:  $localize `Senegal`},
      {value: 'RS', viewValue:  $localize `Serbia`},
      {value: 'SC', viewValue:  $localize `Seszele`},
      {value: 'SL', viewValue:  $localize `Sierra Leone`},
      {value: 'SG', viewValue:  $localize `Singapur`},
      {value: 'SX', viewValue:  $localize `Sint Maarten`},
      {value: 'SK', viewValue:  $localize `Słowacja`},
      {value: 'SI', viewValue:  $localize `Słowenia`},
      {value: 'SO', viewValue:  $localize `Somalia`},
      {value: 'LK', viewValue:  $localize `Sri Lanka`},
      {value: 'US', viewValue:  $localize `Stany Zjednoczone`},
      {value: 'SD', viewValue:  $localize `Sudan`},
      {value: 'SS', viewValue:  $localize `Sudan Południowy`},
      {value: 'SR', viewValue:  $localize `Surinam`},
      {value: 'SJ', viewValue:  $localize `Svalbard i Jan Mayen`},
      {value: 'SY', viewValue:  $localize `Syria`},
      {value: 'CH', viewValue:  $localize `Szwajcaria`},
      {value: 'SE', viewValue:  $localize `Szwecja`},
      {value: 'TJ', viewValue:  $localize `Tadżykistan`},
      {value: 'TH', viewValue:  $localize `Tajlandia`},
      {value: 'TW', viewValue:  $localize `Tajwan`},
      {value: 'TZ', viewValue:  $localize `Tanzania`},
      {value: 'TL', viewValue:  $localize `Timor Wschodni`},
      {value: 'TG', viewValue:  $localize `Togo`},
      {value: 'TK', viewValue:  $localize `Tokelau`},
      {value: 'TO', viewValue:  $localize `Tonga`},
      {value: 'TT', viewValue:  $localize `Trynidad i Tobago`},
      {value: 'TN', viewValue:  $localize `Tunezja`},
      {value: 'TR', viewValue:  $localize `Turcja`},
      {value: 'TM', viewValue:  $localize `Turkmenistan`},
      {value: 'TC', viewValue:  $localize `Turks i Caicos`},
      {value: 'TV', viewValue:  $localize `Tuvalu`},
      {value: 'UG', viewValue:  $localize `Uganda`},
      {value: 'UA', viewValue:  $localize `Ukraina`},
      {value: 'UY', viewValue:  $localize `Urugwaj`},
      {value: 'UZ', viewValue:  $localize `Uzbekistan`},
      {value: 'VU', viewValue:  $localize `Vanuatu`},
      {value: 'WF', viewValue:  $localize `Wallis i Futuna`},
      {value: 'VA', viewValue:  $localize `Watykan`},
      {value: 'VE', viewValue:  $localize `Wenezuela`},
      {value: 'HU', viewValue:  $localize `Węgry`},
      {value: 'GB', viewValue:  $localize `Wielka Brytania`},
      {value: 'VN', viewValue:  $localize `Wietnam`},
      {value: 'IT', viewValue:  $localize `Włochy`},
      {value: 'CI', viewValue:  $localize `Wybrzeże Kości Słoniowej`},
      {value: 'BV', viewValue:  $localize `Wyspa Bouveta`},
      {value: 'CX', viewValue:  $localize `Wyspa Bożego Narodzenia`},
      {value: 'IM', viewValue:  $localize `Wyspa Man`},
      {value: 'SH', viewValue:  $localize `Wyspa Świętej Heleny, Wyspa Wniebowstąpienia i Tristan da Cunha`},
      {value: 'AX', viewValue:  $localize `Wyspy Alandzkie`},
      {value: 'CK', viewValue:  $localize `Wyspy Cooka`},
      {value: 'VI', viewValue:  $localize `Wyspy Dziewicze Stanów Zjednoczonych`},
      {value: 'HM', viewValue:  $localize `Wyspy Heard i McDonalda`},
      {value: 'CC', viewValue:  $localize `Wyspy Kokosowe`},
      {value: 'MH', viewValue:  $localize `Wyspy Marshalla`},
      {value: 'FO', viewValue:  $localize `Wyspy Owcze`},
      {value: 'SB', viewValue:  $localize `Wyspy Salomona`},
      {value: 'ST', viewValue:  $localize `Wyspy Świętego Tomasza i Książęca`},
      {value: 'ZM', viewValue:  $localize `Zambia`},
      {value: 'ZW', viewValue:  $localize `Zimbabwe`},
      {value: 'AE', viewValue:  $localize `Zjednoczone Emiraty Arabskie`}
    ],

    decoder_types: {
        'A': {param: '',  client: $localize `Pod agregaty`},
        'B': {param: '',  client: $localize `Podłodziowa`},
        'C': {param: '',  client: $localize `Pod poduszkowce`},
        'I': {param: '',  client: $localize `Inna`},
        'K': {param: '',  client: $localize `Pod koparki`},
        'L': {param: '',  client: $localize `Laweta`},
        'M': {param: '',  client: $localize `Podmotocyklowa`},
        'P': {param: '',  client: $localize `Platforma`},
        'R': {param: '',  client: $localize `Pod rowery`},
        'S': {param: '',  client: $localize `Skrzyniowa`}
    },

    decoder_axis: {
        '1': {param: '',  client: $localize `1 oś`},
        '2': {param: '',  client: $localize `2 osie`},
        '3': {param: '',  client: $localize `3 osie`},
        '4': {param: '',  client: $localize `4 osie`},
    },

    decoder_drawbars: {
        'V': {param: '',  client: $localize `Dyszel V`},
        'T': {param: '',  client: $localize `Dyszel T`}
    },

    decoder_wheels: {
        'P': {param: '',  client: $localize `pod podłogą`},
        'Z': {param: '',  client: $localize `na zewnątrz`}
    },

    decoder_suspension: {
        'O': {param: '',  client: $localize `oś skrętna`},
        'W': {param: '',  client: $localize `wahacze`},
        'R': {param: '',  client: $localize `resory`}
    },
  
    decoder_segments: {
      1: {
          1: {
              'name': {param: '',  client: $localize `Marka osi`},
              'A': {param: '',  client: $localize `AL-KO`},
              'K': {param: '',  client: $localize `KNOTT`},
              'U': {param: '',  client: $localize `AL-KO lub KNOTT`},
              'C': {param: '',  client: $localize `inna`},
              },
          2: {
              'name': {param: '',  client: $localize `Podłoga`},
              'L': {param: '',  client: $localize `Laweta / lohr stal`},
              'S': {param: '',  client: $localize `Pełna podłoga sklejkowa`},
              'A': {param: '',  client: $localize `Pełna podłoga aluminiowa`},
              'B': {param: '',  client: $localize `Brak podłogi`},
              'D': {param: '',  client: $localize `Lohry aluminiowe z wypełnieniem auluminiowym bez sklejki`},
              'H': {param: '',  client: $localize `Panel podłogowy aluminiowy`},
              'X': {param: '',  client: $localize `Lohry stalowe z wypełnieniem aluminiowym + sklejka`},
              'Y': {param: '',  client: $localize `Lohry stalowe z wypełnieniem sklejkowym`},
              'Z': {param: '',  client: $localize `Lohry aluminiowe z wypełnieniem aluminiowym + sklejka`},
              'V': {param: '',  client: $localize `Lohry stalowe z wypełnieniem aluminiowym bez sklejki`},
              'Q': {param: '',  client: $localize `Lohry aluminiowe`},
              'T': {param: '',  client: $localize `Podłoga stalowa`},
              'G': {param: '',  client: $localize `Podłodziowa`},
              'P': {param: '',  client: $localize `Podłodziowa`},
              'C': {param: '',  client: $localize `Podłodziowa`},
              },
          3: {
              'name': {param: '',  client: $localize `Koła`},
              '0': {param: '',  client: $localize `195/55 R10C`},
              '1': {param: '', client: $localize `165/70R13 4x100`},
              '2': {param: '',  client: $localize `165R13C 5x112`},
              '3': {param: '',  client: $localize `195/50 R13C`},
              '4': {param: '',  client: $localize `185 R14C`},
              'N': {param: '',  client: $localize `155/70 R13`},
              },
          5: {
            'name': {param: '',  client: $localize `Wersja przyczepy`},
            'R': {param: '',  client: $localize `Podpory rolkowe + mocowania`},
            'C': {param: '',  client: $localize `Podpory płaskie + mocowania`},
            'P': {param: '',  client: $localize `Bez podpór i mocowań`},
            'J': {param: '',  client: $localize `Podpory JODMET + mocowania`},
          },
          4: {
              'name': {param: '',  client: $localize `Wersja przyczepy`},
              'E': {param: '',  client: $localize `europejska`},
              'B': {param: '',  client: $localize `brytyjska`},
              'C': {param: '',  client: $localize `europejska bez VIN`},
              'D': {param: '',  client: $localize `brytyjska bez VIN`},
              'F': {param: '',  client: $localize `STUSSI`},
              'A': {param: '',  client: $localize `USA bez VIN`},
              }
      },

      2: {
          1: {
              'name': {param: '',  client: $localize `Układ podnoszenia`},
              'T': {param: '',  client: $localize `ręczny`},
              'U': {param: '',  client:  $localize `elektryczny`},
              'V': {param: '',  client:  $localize `elektryczny+ręczny`}
          }
      },

      3: {
          1: {
              'name': {param: '',  client: $localize `Wyposażenie`},
              'A': {param: '',  client: $localize `Wspornik koła zapasowego`},
              'B': {param: 'kolo_zapasowe_wspornik',  client: $localize `Wspornik koła zapasowego + koło zapasowe`},
              'C': {param: 'burty_alu',  client: $localize `Burty aluminiowe`},
              'D': {param: '',  client: $localize `Burty stal + sklejka`},
              'D1': {param: '',  client: $localize `Uchwyty boczne`},
              'D2': {param: '',  client: $localize `Oświetlenie full LED`},
              'D3': {param: '',  client: $localize `Podpora boczna z klemą RSR - przód / tył`},
              'D4': {param: '',  client: $localize `Agregat GOVI`},
              'D5': {param: '',  client: $localize `Agregat CIBIN`},
              'D6': {param: '',  client: $localize `Przedłużacz 3M`},
              'D7': {param: '',  client: $localize `Przedłużacz 10M`},
              'D8': {param: '',  client: $localize `Najazd pełny stalowy + podnośnik korbowy`},
              'D9': {param: '',  client: $localize `Brak ramki tablicy rejestracyjnej`},
              'E': {param: 'amortyzatory',  client: $localize `Amortyzatory`},
              'E1': {param: '',  client: $localize `Blokator koła LOHR regulaowany szary - malowany`},
              'F': {param: 'aks',  client: $localize `AKS`},
              'G': {param: 'kolo_podporowe',  client: $localize `Koło podporowe automatyczne`},
              'H': {param: 'podpora_reg',  client: $localize `Podpora boczna komplet`},
              'I': {param: '',  client: $localize `Podpora boczna (bez adaptera)`},
              'J': {param: '',  client: $localize `Wspornik wciągarki`},
              'J1': {param: '',  client: $localize `Zamontowane podpory JODMET`},
              'K1': {param: 'wciagarka',  client: $localize `Wciągarka z linką`},
              'K2': {param: 'wciagarka',  client: $localize `Wciągarka z pasem`},
              'K3': {param: 'wciagarka',  client: $localize `Wciągarka AL-KO`},
              'K4': {param: 'wciagarka',  client: $localize `Wciagarka KNOTT`},
              'K5': {param: 'wciagarka',  client: $localize `Wciągarka z linką i hamulcem`},
              'L': {param: '',  client: $localize `Okrągłe KNOTT`},
              'M': {param: '',  client: $localize `Kolo podporowe z klemą`},
              'N': {param: '',  client: $localize `Reling przedni`},
              'O': {param: '',  client: $localize `Relingi boczne`},
              'P': {param: 'najazdy',  client: $localize `Najazdy stalowe pojedyńcze`},
              'R': {param: 'najazdy',  client: $localize `Najazdy aluminiowe pojedyńcze`},
              'R1': {param: '',  client: $localize `Podpory rolkowe Duńskie`},
              'R2': {param: '',  client: $localize `Podpory rolkowe Rolgum`},
              'S': {param: '',  client: $localize `Najazdy 1500/250`},
              'W': {param: '',  client: $localize `Belka oświetleniowa aluminiowa`},
              'X': {param: '',  client: $localize `Podpora boczna z klemą RSR`},
              'Y': {param: '',  client: $localize `Wzmocnienia burt`},
              'Z': {param: '',  client: $localize `Burty stalowe`},
              'A1': {param: 'blokator-kola',  client: $localize `Blokator koła sztanga`},
              'A2': {param: '',  client: $localize `Blokator koła LOHR`},
              'A3': {param: '',  client: $localize `Burta tylna najazdowa`},
              'A4': {param: '',  client: $localize `Blokator skręcany`},
              'A5': {param: '',  client: $localize `Blokator spawany`},
              'A6': {param: '',  client: $localize `Burty stalowe H400`},
              'A7': {param: '',  client: $localize `Burty stalowe H400 + sklejka`},
              'A8': {param: '',  client: $localize `Szara sklejka`},
              'A9': {param: '',  client: $localize `Układ podnoszenia / podnośnik korbowy`},
              'B1': {param: '',  client: $localize `Błotniki z wysuwanymi obrysówkami`},
              'B2': {param: '',  client: $localize `Czarne koła`},
              'B3': {param: '',  client: $localize `Najazd pełny stalowy`},
              'B4': {param: '',  client: $localize `Oś 1800`},
              'B5': {param: '',  client: $localize `Prowadnice do najazdów bez najazdów`},
              'B6': {param: '',  client: $localize `Podwójna dziobnica aluminiowa`},
              'B7': {param: '',  client: $localize `FELGI ALU`},
              'B8': {param: '',  client: $localize `DZIOBNICA DUZA STALOWA 2xV`},
              'B9': {param: '',  client: $localize `BEZ BURT`},
              'B10': {param: '',  client: $localize `WERSJA_LAKKAPA`},
              'C1': {param: '',  client: $localize `Układ Flexipump`},
              'C2': {param: '',  client: $localize `PŁYTA PVC`},
              'C3': {param: '',  client: $localize `RELING KPL.`},
              'C4': {param: '',  client: $localize `Wzmocnienie ramy kpl. dodatkowych poprzeczek`},
              'C5': {param: '',  client: $localize `Burty spawane H400`},
              'C6': {param: '',  client: $localize `Najazd pełny aluminiowy`},
              'C7': {param: '',  client: $localize `Burty aluminiowe - przednia i boczne `},
              'C8': {param: '', client: $localize `Koła do QUADa - kostka`},
              'C9': {param: '',  client: $localize `Burty stalowe z wypełnieniem stalowym`},
          }
      }
    },

    filterData(data: any[], modifier: string, type: string, section: string, id = 0, parent_id = 0) {

        if (parent_id === 1) {
            parent_id = 0; // reset to 0 on top level or we get all top level items via parent id
        }

        var r = data.filter((page: Page) =>  {
            if (page.children) page.children = this.filterData(page.children, modifier, type, section, id, parent_id);
            if (modifier === '!==') {
                return (page.module !== type && +page.visible === 1 && page.visible_in.includes(section))
            } else if (modifier === '===') {
                return (page.module === type && +page.visible === 1 && page.visible_in.includes(section))
            } else if (id > 0 && section){  // in section
                return ((+page.parent_id === id || +page.id === id || +page.parent_id === parent_id || +page.id === parent_id) && +page.visible === 1 && page.visible_in.includes(section))
            } else if (id > 0 && !section){ // whatever
                return ((+page.parent_id === id || +page.id === id || +page.parent_id === parent_id || +page.id === parent_id) && +page.visible === 1)
            }
        })
        return r;
    },

    calculateDiscountPrice(discounts: any[], category: any[], manufacturer: number, tax: number,  price_promo: number,  price: number, id: number, cart = false) {

      tax = price * (tax / 100);
      let modprice_old = 0;
      let discounted = false;
      let modprice = Math.round((+price + +tax) * 100) / 100;
      modprice = Math.round(modprice * 100) / 100;

      if (discounts) {
          let last_discount_value = 0;
          console.log('---------------------');
          discounts.forEach(discount => {
            let d_val = 0;
            if (discount.type === 'percent') {
              if (discount.type_calculation === 'cascade' && discount.code) {
                const discountPrice = +modprice - last_discount_value;
                d_val = discountPrice * (+discount.value / 100);
              } else {
                d_val = +modprice * (+discount.value / 100);
              }
              d_val = Math.round( d_val * 100 + Number.EPSILON ) / 100;
            }  else if (discount.type === 'amount') {
              d_val = +discount.value;
            }
            
            // console.log('1', discount.name, discount.type_calculation, discount.code, d_val, cart);
            if (discount.code && (discount.type_calculation === 'add' || discount.type_calculation === 'cascade') && cart) { //if code, sum with previous
              // console.log('ADD', last_discount_value);
              d_val = last_discount_value + d_val;
              modprice_old =  modprice - d_val;
              last_discount_value = d_val;
              discounted = true; 
            }
            // console.log('2', discount.name, discount.type_calculation, discount.code, d_val);
    
            if (discount.visible <  5) { // withouth popups
              if (discount.products_id) {
                // PRODUCT DISCOUNT
                const discount_products = discount.products_id.split(',').map( Number ) || undefined;
                const result = discount_products.includes(+id);
                if (result) {
                    if (last_discount_value < d_val) {
                      modprice_old =  modprice - d_val;
                      last_discount_value = d_val;
                      discounted = true;
                      // console.log('product', last_discount_value, d_val);
                    }
                }
              } 
              if (discount.categories_id && category) {
                // // CATEGORY DISCOUNT
                const discount_categories = discount.categories_id.split(',').map( Number ) || undefined;
                const result = category.some( (e: any) => discount_categories.includes(+e.id_page) );
                if (result) {
                    if (last_discount_value < d_val) {
                      modprice_old =  modprice - d_val;
                      last_discount_value = d_val;
                      discounted = true;
                    }
                }
              } 
              if (discount.manufacturers_id) {
                // MANUFACTURER DISCOUNT
                const discount_manufacturers = discount.manufacturers_id.split(',').map( Number ) || undefined;
                if (discount_manufacturers.includes(+manufacturer)) {
                    if (last_discount_value < d_val) {
                      modprice_old = modprice - d_val;
                      last_discount_value = d_val;
                      discounted = true;
                      // console.log('producent', last_discount_value, d_val);
                    }
                }
              }

              if (discount.groups_id) {
                // MANUFACTURER DISCOUNT
                const discount_groups = discount.groups_id.split(',').map( Number ) || undefined;

                let id_client = localStorage.getItem('user_id') || null;
                if ([26,5,4].includes(+id_client) && discount_groups.includes(2)) {
                    if (last_discount_value < d_val) {
                      modprice_old = modprice - d_val;
                      last_discount_value = d_val;
                      discounted = true;
                      // console.log('producent', last_discount_value, d_val);
                    }
                }
              }
              
            }
           
            modprice_old = Math.round(modprice_old * 100) / 100;
          });
          // console.log('---------------------');
        }

        let final = (modprice_old ? modprice_old : modprice);

        return Math.round(final * 10) / 10;
  },

    scrollTo(to: number, callback: any, duration: number) {
        // because it's so fucking difficult to detect the scrolling element, just move them all
        function move(amount) {
            document.documentElement.scrollTop = amount;
            document.body.scrollTop = amount;
        }
        function position() {
            return document.documentElement.scrollTop  || document.body.scrollTop;
        }

        var requestAnimFrame = (function(){
            return  window.requestAnimationFrame || function( callback ){ window.setTimeout(callback, 1000 / 60); };
        })();

        var start = position(),
            change = to - start,
            currentTime = 0,
            increment = 20;
        duration = (typeof(duration) === 'undefined') ? 500 : duration;
        var animateScroll = function() {
            // increment the time
            currentTime += increment;
            // find the value with the quadratic in-out easing function
            var val = utils.easeInOutQuad(currentTime, start, change, duration);
            // move the document.body
            move(val);
            // do the animation unless its over
            if (currentTime < duration) {
                requestAnimFrame(animateScroll);
            } else {
            if (callback && typeof(callback) === 'function') {
                // the animation is done so lets callback
                callback();
            }
            }
        };
        animateScroll();
    },

    uuidv4() {
      return (<any>[1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c =>
        (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
      );
    },

    easeInOutQuad (t, b, c, d) {
        t /= d/2;
        if (t < 1) {
            return c/2*t*t + b
        }
        t--;
        return -c/2 * (t*(t-2) - 1) + b;
    },

    updateCode (code: string, attributes: any[]) {
      //segment: "1", segment_2: 3, value: "3"

      // console.log(code, attributes);
      const code_parts = code.split('_');
      if (environment.name == 'Martz') code_parts.shift();
      const code_parts_array = [[], [], [], []];
      if (code_parts.length > 1) {
        let changed = code_parts[0];

        if (code_parts[1]){
          code_parts_array[1] = [...code_parts[1]];
          // code_parts_array[1].forEach(letter => {
          //   console.log('LETTER ', letter);
          // });
        }

        if (code_parts.length > 2){

          for (let index = code_parts.length-2; index > 0; index--) {
            let original = code_parts[code_parts.length-index].split(/(?=[A-Z])/);
            original.forEach(letter => {
                let found = false;
                for (const [key, a] of Object.entries(attributes)) {
                  if (a.value.value == letter) { //key == this.decoder_segments[3][1][letter].param
                    found = true;
                  }
                  if (a.values) {
                    if (a.values.includes(letter)) {
                      found = true;
                    }
                  }
                  
                };
                if (!found) {
                  //4 - max length
                  attributes.push({value: {segment: 4-index, segment_2: 1, value: letter}});
                }
            });

          }
          
        }

        if (code_parts[2]?.length == 1) { //hamulec
            if (['T', 'U', 'V'].includes(code_parts[2][0])) {
              // console.log('hamulec');
              code_parts_array[2][0] = code_parts[2][0];
            }
        }

        for (const [key, attr] of Object.entries(attributes)) {
          const change = attr.value;
          if (change.segment && change.segment_2) {
            if (this.decoder_segments[+change.segment][+change.segment_2]) {
              if (this.decoder_segments[+change.segment][+change.segment_2][change.value]) {
                if (+change.segment === 3) {
                  code_parts_array[3].push(change.value);
                } else {
                  code_parts_array[+change.segment][+change.segment_2-1] = change.value;
                }
              }
            }
          } else {
            // console.log(key, attr);
          }
        }


        if (code_parts_array[1].length) changed += '_'+code_parts_array[1].join('');
        if (code_parts_array[2].length) changed += '_'+code_parts_array[2].join('');
        if (code_parts_array[3].length) changed += '_'+code_parts_array[3].sort((a, b) => a.localeCompare(b)).join('');
        if (environment.name == 'Martz') changed = 'M_'+changed;
        // console.log(changed);
        return changed;
      }
      return code;
    },

    getLink(url: string) {
      const res = url.split('?');
      return res[0];
    },
    
    getParams(queryString: string) {
      const q = {};
      const paramsPart = queryString.split('?')[1];
      if (paramsPart) {
        const pairs = (paramsPart[0] === '?' ? paramsPart.substr(1) : paramsPart).split('&');
        for (let i = 0; i < pairs.length; i++) {
          const pair = pairs[i].split('=');
          q[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1] || '');
        }
      }
      return q;
    }
};

